import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import { useEffect } from "react";
import WOW from "wow.js";
import HomeTwo from "./pages/Home/HomeTwo";
import Blog from "./pages/Blog/Blog";
import TransformingHealthcareWithBlockchain from "./pages/BlogDetails/TransformingHealthcareWithBlockchain";
import AIBlockchaininHealthcare from "./pages/BlogDetails/AIBlockchaininHealthcare";
import DIAGTokenFutureHealthcarePayments from "./pages/BlogDetails/DIAGTokenFutureHealthcarePayments";
import { useLocation } from "react-router-dom";
import PresaleForm from "./components/Banner/PresaleModal";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="home-two" element={<HomeTwo />} />
        <Route path="blog" element={<Blog />} />
        <Route path="TransformingHealthcareWithBlockchain" element={<TransformingHealthcareWithBlockchain />} />
        <Route path="AIBlockchaininHealthcare" element={<AIBlockchaininHealthcare />} />
        <Route path="DIAGTokenFutureHealthcarePayments" element={<DIAGTokenFutureHealthcarePayments />} />
        <Route path="/presale" element={<PresaleForm />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookie" element={<Cookie />} />


      </Routes>
    </>
  );
}

export default App;
